export default {
  allSelected: 'Todas las {entity} han sido seleccionadas.',
}
